// Angular Imports
import { Component, OnInit, Input, Injector } from '@angular/core';

// Component imports
import { MPSearchBaseComponent } from '../_base/mp-base-search.component';

// Service imports
import { ServerErrorService } from '../../_services/shared-services/server-error.service';
import { SearchService } from '../_services/data-services/search.service';

// Model imports
import { SearchParametersDto } from '../_models/search-parameters-dto';
import { SearchViolationNoticesResultDto } from '../_models/search-violation-notices-result-dto';

@Component({
    selector: 'app-search-violation-notices',
    templateUrl: './search-violation-notices.component.html',
    styleUrls: ['./search-violation-notices.component.scss']
})
export class SearchViolationNoticesComponent extends MPSearchBaseComponent implements OnInit {
    @Input() communityId: number;

    violationNotices: SearchViolationNoticesResultDto[] = [];

    showRegarding = true;
    gridRowIndex: number;

    constructor(
        protected readonly injector: Injector,
        private readonly errorService: ServerErrorService,
        private readonly searchService: SearchService
    ) {
        super(injector);
    }

    ngOnInit() {
        if (!!this.searchText) {
            this.searchviolationNotices();
        }
    }

    downloadFile(data: SearchViolationNoticesResultDto): void {
        const fileName = `${data.accountNumber}_${data.violationNoticeId}.pdf`;
        if (!!data) {
            this.helperService.downloadFileUsingUrl(data.noticeUrl, fileName);
        }
    }

    toggleRegarding(row: any): void {
        if (!!row) {
            this.gridRowIndex = row.rowIndex;
            this.showRegarding = !this.showRegarding;
        }
    }

    searchviolationNotices() {
        const param: SearchParametersDto = new SearchParametersDto();
        param.clearCache = true;
        param.searchText = this.searchText;
        param.communityId = this.communityId;
        this.violationNotices = [];
        this.loadingVisible = true;
        this.searchService.searchViolationNotices(param).subscribe(
            (data) => {
                this.violationNotices = data;
                this.loadingVisible = false;
            },
            (error) => {
                this.errorService.displayError(error);
                this.loadingVisible = false;
            }
        );
    }
}
